/**
 * Use Case: Criar Estágio do Funil
 * Orquestra a criação de um novo estágio do funil de vendas
 */

import { IFunnelStageRepository } from '../../../domain/repositories/IFunnelStageRepository';
import { FunnelStage } from '../../../domain/entities/FunnelStage';

export interface CreateFunnelStageDTO {
    name: string;
    conversionEvent: string;
    funnelId?: string;
    order?: number;
    deadline?: number;
    color?: string | null;
    organizationId?: string;
}

export class CreateFunnelStageUseCase {
    constructor(private readonly funnelStageRepository: IFunnelStageRepository) { }

    async execute(dto: CreateFunnelStageDTO): Promise<FunnelStage> {
        // Gera ID temporário
        const tempId = `temp_${Date.now()}`;

        // Cria entidade (validações automáticas)
        const stage = new FunnelStage(
            tempId,
            dto.name,
            dto.conversionEvent,
            new Date(),
            dto.funnelId,
            dto.order || 0,
            dto.deadline,
            dto.color || null
        );

        // Persiste
        await this.funnelStageRepository.save(stage, dto.organizationId);

        return stage;
    }
}
